import { Button } from '@modulor/react';
import withAnalytics from '../../hocs/withAnalytics';

export const VARIANTS = {
  PRIMARY: 'primary',
  DEPOSIT: 'deposit',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  WHITE: 'white',
  ALWAYS_WHITE: 'always_white',
  TEXT_BUTTON: 'text_button',
};

export const ModulorButtonWithAnalytics = withAnalytics(Button);
